<gridster [options]="options">
    <gridster-item [item]="item" *ngFor="let item of dashboard">
      <!-- your content here -->
    </gridster-item>
  </gridster>